import * as PIXI from "pixi.js";
import Layers from "../../../layers/Layers";


export default class CheckboxRenderer extends PIXI.Container {
  private Layers = Layers.getInstance();
  public con = this.addChild(new PIXI.Container());
  private checkedSquare = this.con.addChild(new PIXI.Graphics());
  private defaultColor = 0xFFFFFF;

  constructor(private color: number, public checkboxLabel: string, useCustomLayer = false) {
    super();
    this.drawCheckbox(false);
    this.addLabel();
    !useCustomLayer && this.addToLayer();
  }
  private addToLayer = () => this.Layers.UI.addChild(this);
  drawCheckbox(isColored: boolean) {
    const fillColor = isColored ? this.color : this.defaultColor;
    this.checkedSquare
      .clear()
      .roundRect(0, -20, 40, 40, 10)
      .fill(fillColor)
      .stroke({ width: 2, color: 0x000000 })
  }
  private addLabel() {
    const text = new PIXI.Text({ text: this.checkboxLabel });
    text.style.fontSize = 36;
    text.style.fill = this.color;
    text.anchor.set(0, .5);
    text.x = 50;
    text.y = 0;
    this.con.addChild(text);
  }
}